import {useContext} from 'react'

import AtomImage from '@s-ui/react-atom-image'
import Context from '@s-ui/react-context'
import {Link} from '@s-ui/react-router'

const LandingInstantOfferTopBar = () => {
  const {domain} = useContext(Context)
  const config = domain.get('config')
  const LOGO_NEGATIVE_URL = config.get('LOGO_NEGATIVE_URL')
  return (
    <div className="mt-LandingInstantOfferTopBar">
      <Link to="/">
        <AtomImage className="mt-LandingInstantOfferTopBarLogo" src={LOGO_NEGATIVE_URL} alt="logo" />
      </Link>
    </div>
  )
}

LandingInstantOfferTopBar.displayName = 'LandingInstantOfferTopBar'

export default LandingInstantOfferTopBar
